import CustomSelect from "@/components/CustomSelect";
import ReactPaginate from "react-paginate";
import { ResultItem } from "@/components/FaqSearch/ResultItem";
import React from "react";
import { FaqHooks } from "@/types/faq";

export const SearchResultsContainer = ( { faqHooks }: { faqHooks: FaqHooks } ) => {
  return (
    <>
      <div className="faq-search-sub-title uk-flex uk-flex-between margin-top-35" ref={faqHooks.onClickSearchScrollRef}>
        <p className="uk-faq-text-medium-l uk-text-bold">
          検索結果：{faqHooks.displayFaqList.length}件中 {faqHooks.firstItemNum + 1}~{faqHooks.lastItemNum}件目
        </p>
        <div className="uk-flex uk-flex-middle">
          <p className="uk-text-default uk-text-bold" translate="no">表示件数：</p>
          <CustomSelect
            options={pageSizeOptions}
            value={faqHooks.pageSize}
            onChange={faqHooks.onChangePageSize}
            className="height-24"
          />
          <p className="uk-text-default uk-text-bold uk-margin-small-left">
            並び順：
          </p>
          <CustomSelect
            options={[{ value: "1", label: "更新日" }, { value: "2", label: "閲覧数" }]}
            value={faqHooks.order}
            onChange={e => faqHooks.setOrder(e.target.value)}
            className="height-24"
          />
        </div>
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top uk-margin-small-bottom">
        <a className="pagination-button" onClick={faqHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(faqHooks.displayFaqList.length / Number(faqHooks.pageSize))}
          onPageChange={faqHooks.onChangePage}
          forcePage={String(faqHooks.currentPage).length > 0 ? faqHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={faqHooks.goToLastPage}>&gt;&gt;</a>
      </div>
      <div className="faq-search-result">
        {faqHooks.currentFaqList.map(( faq, index ) => <ResultItem faq={faq} index={index} key={index}/>)}
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top">
        <a className="pagination-button" onClick={faqHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(faqHooks.displayFaqList.length / Number(faqHooks.pageSize))}
          onPageChange={faqHooks.onChangePage}
          forcePage={String(faqHooks.currentPage).length > 0 ? faqHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={faqHooks.goToLastPage}>&gt;&gt;</a>
      </div>
    </>
  )
}


const pageSizeOptions = [
  { value: "10", label: "10件" },
  { value: "20", label: "20件" },
  { value: "50", label: "50件" },
  { value: "100", label: "100件" }
]